var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InsightDisplay',{attrs:{"insight":_vm.data,"compact":_vm.compact,"dark-background":_vm.darkBackground,"evolutive-kpis":_vm.evolutiveKpis,"display-kpi":_vm.displayKpi},scopedSlots:_vm._u([{key:"thumbnail",fn:function(){return [_c('div',{staticClass:"brand-name"},[_vm._v(_vm._s(_vm.data.name))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }